



















































import { Vue, Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import logger from "@/configs/logger";
import { collections } from "@/configs/firebase";

@Component
export default class Products extends Vue {
  loading = false;
  search = "";
  products: any[] = [];
  headers = [
    {
      text: "Product name",
      value: "name"
    },
    {
      text: "Commission",
      value: "commission"
    },
    {
      text: "Enrollment fee opts",
      value: "enrollment_fee_options",
      width: "140px"
    },
    {
      text: "Group",
      value: "group"
    },
    {
      text: "Premium",
      value: "premium"
    },
    {
      text: "Type",
      value: "type"
    },
    {
      text: "ID (enrollment 123)",
      value: "enrollment123_product_id",
      width: "140px"
    },
    {
      text: "State whitelist",
      value: "state_whitelist"
    },
    {
      text: "Status",
      value: "is_active",
      align: "center"
    }
  ];

  mounted() {
    this.loadProdcuts();
  }

  async loadProdcuts() {
    try {
      this.loading = true;
      const snapshot = await collections.productOptions.get();
      this.products = snapshot.docs.map(item => ({
        ...item.data(),
        id: item.id
      }));
    } catch (err) {
      logger("error", "fetch products error:", err);
    } finally {
      this.loading = false;
    }
  }
}
